import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { MatGridListModule } from '@angular/material/grid-list';
import { OrdersParserService } from 'src/app/core/services/orders-parser';
import * as fromReducer from '../store/reducers';
import * as fromNodesReducer from '../store/reducers/nodes.reducer';
import * as fromUsersReducer from '../store/reducers/users.reducer';

import { SharedModule } from '../shared/shared.module';
import { WidgetDirective } from './widget.directive';

import { BulletStatusComponent } from './bullet-status/bullet-status.component';
import { CircuitMilestonesComponent } from './circuit-milestones/circuit-milestones.component';
import { PendingFocDatesComponent } from './pending-foc-dates/pending-foc-dates.component';
import { ServiceOverviewComponent } from './service-overview/service-overview.component';
import { SummaryComponent } from './summary-page/summary-page.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    MatGridListModule,
    StoreModule.forFeature('billing', fromReducer.billingReducers),
    StoreModule.forFeature('nodes', fromNodesReducer.reducer),
    StoreModule.forFeature('user', fromUsersReducer.reducer),
    StoreModule.forFeature('tickets', fromUsersReducer.reducer),
  ],
  declarations: [
    SummaryComponent,
    WidgetDirective,
    BulletStatusComponent,
    ServiceOverviewComponent,
    CircuitMilestonesComponent,
    PendingFocDatesComponent,
  ],
  providers: [DecimalPipe, OrdersParserService],
})
export class SummaryModule {}
